import React from 'react'
import HighLightsBG from "../../../assets/images/Journey.jpg"
import Shape12 from "../../../assets/images/shape-12.png"

const HighLights = () => {
    return (
        <div>
            <section className="highlights-style-two">
                <div className="bg-layer" style={{ backgroundImage: `url(${HighLightsBG})` }}></div>
                <div className="shape">
                    <div className="shape-2 float-bob-x" style={{ backgroundImage: `url(${Shape12})` }}></div>
                </div>
                <div className="auto-container">
                    <div className="sec-title light">
                        <h2>Helping You Become a Great Rider</h2>
                        <p>At Precision Driving, we believe that learning to drive should be a rewarding and confidence-building experience. Our expert instructors, modern techniques, and trusted reputation ensure you receive the best training to become a skilled and responsible rider. </p>
                    </div>
                    <div className="row clearfix">
                        <div className="col-lg-6 col-md-6 col-sm-12 single-column">
                            <div className="single-item wow fadeInLeft animated animated" data-wow-delay="00ms" data-wow-duration="1500ms" >
                                <div className="inner">
                                    <ul className="icon-list">
                                        <li><i className="bi bi-chevron-double-right"></i></li>
                                        <li><i className="bi bi-chevron-double-right"></i></li>
                                    </ul>
                                    <h4><a href="#">Approved Institute</a></h4>
                                    <p>We are a fully accredited driving school, committed to providing top-tier instruction that meets industry standards. Our courses are designed to equip you with the knowledge and skills necessary for safe and confident driving. </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 single-column">
                            <div className="single-item wow fadeInRight animated animated" data-wow-delay="00ms" data-wow-duration="1500ms" >
                                <div className="inner">
                                    <ul className="icon-list">
                                        <li><i className="bi bi-chevron-double-right"></i></li>
                                        <li><i className="bi bi-chevron-double-right"></i></li>
                                    </ul>
                                    <h4><a href="#">Experienced &amp; Trusted</a></h4>
                                    <p> With years of experience and a reputation built on trust, our instructors are dedicated to guiding you through every step of your driving journey. Whether you're a beginner or looking to refine your skills, we provide personalised training to suit your needs. </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 single-column">
                            <div className="single-item wow fadeInLeft animated animated" data-wow-delay="300ms" data-wow-duration="1500ms">
                                <div className="inner">
                                    <ul className="icon-list">
                                        <li><i className="bi bi-chevron-double-right"></i></li>
                                        <li><i className="bi bi-chevron-double-right"></i></li>
                                    </ul>
                                    <h4><a href="#">Modern Techniques</a></h4>
                                    <p>We incorporate the latest driving methods and technologies to ensure you receive up-to-date training. From defensive driving strategies to advanced manoeuvring techniques, we prepare you for real-world driving challenges. </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 single-column">
                            <div className="single-item wow fadeInRight animated animated" data-wow-delay="300ms" data-wow-duration="1500ms" >
                                <div className="inner">
                                    <ul className="icon-list">
                                        <li><i className="bi bi-chevron-double-right"></i></li>
                                        <li><i className="bi bi-chevron-double-right"></i></li>
                                    </ul>
                                    <h4><a href="#">Trained Instructors</a></h4>
                                    <p>Our professional instructors are highly qualified, patient, and passionate about teaching. They tailor lessons to your learning pace, ensuring you feel comfortable and confident behind the wheel.  <span className='fix-content-box'>Start your journey with a great guidance.</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default HighLights
